import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { PreferencesService } from '@services/preferences/preferences.service';

@Injectable({
    providedIn: 'root',
})
export class CompanyLocaleInterceptor implements HttpInterceptor {
    constructor(private preferencesService: PreferencesService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const locale = this.preferencesService.timeLocale;
        const modifiedReq = req.clone({
            headers: req.headers.set('x-company-locale', `${locale}`),
        });
        return next.handle(modifiedReq);
    }
}
